import React from "react";
import Container from "react-bootstrap/Container";

const Footer = () => {
  return (
    <footer data-aos="fade-in" data-aos-delay="200" data-aos-offset="-10">
      <Container fluid className="py-3">
        <h4 className="text-center m-0">Thanks for visiting!</h4>
      </Container>
    </footer>
  );
};

export default Footer;
